var map = {
	"./architecture.png": "5b49",
	"./architecture.svg": "7c13",
	"./business.png": "7c10",
	"./business.svg": "38a0",
	"./care-service.svg": "d93f",
	"./corporate-life.png": "3b38",
	"./corporate-life.svg": "dac3",
	"./medical-equipment.svg": "f315",
	"./medicines-help.svg": "0776",
	"./orange-bg.png": "e2b3",
	"./orange-corner.svg": "d73f",
	"./standard-set.png": "4379",
	"./standard-set.svg": "b59e",
	"./supplies.svg": "17af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2de2";